import { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';

/**
 * Total unread INBOUND SMS for a facility (tenant replies the operator hasn't
 * opened). Polled every 30s so a freshly-arrived text bumps the count. Drives
 * the unread badges (left-nav Messages, the Settings → Communication tab, …).
 * Outbound texts the operator sends are never "unread", so sending one does
 * NOT increment this — only a tenant texting IN does.
 */
export default function useSmsUnread(facilityId) {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    if (!facilityId) { setUnread(0); return undefined; }
    let active = true;
    const fetchCount = async () => {
      try {
        const res = await apiClient.get(`/api/facilities/${facilityId}/sms/unread-count`);
        if (active) setUnread(res?.data?.unread_count || 0);
      } catch (_) {
        // best-effort badge
      }
    };
    fetchCount();
    const id = setInterval(fetchCount, 30000);
    return () => { active = false; clearInterval(id); };
  }, [facilityId]);
  return unread;
}
